import { render } from "./UserNewView.vue?vue&type=template&id=1ee6af58"
import script from "./UserNewView.vue?vue&type=script&lang=js"
export * from "./UserNewView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__